// extracted by mini-css-extract-plugin
module.exports = {"controls":"ContentControls_controls__ybFmO"};